import type { QueryClient } from '@tanstack/react-query';

import type { User } from '../domain/user';
import { userApi } from '../features/user/api';
import userQueryKey from '../features/user/userQueryKey';

export type LoginCallback = (success: boolean) => void | Promise<void>;

let activeCallback: LoginCallback | null = null;
let activeInterval: ReturnType<typeof setInterval> | null = null;

const cleanup = (): void => {
  activeCallback = null;
  activeInterval = null;
};

export const openLoginWindow = (queryClient: QueryClient, onComplete?: LoginCallback): void => {
  // Clear any existing login window
  if (activeInterval) {
    clearInterval(activeInterval);
    activeInterval = null;
  }

  const width = 600;
  const left = screen.width - width;
  const connectedWindow = window.open(
    '/sales-extension/login',
    '_blank',
    `location=0,status=0,titlebar=0,toolbar=0,width=${width}px,height=850px,resizable=yes,left=${left},top=0`
  );

  activeCallback = onComplete || null;

  const interval: ReturnType<typeof setInterval> = setInterval(() => {
    if (!connectedWindow) {
      clearInterval(interval);
      void activeCallback?.(false);
      cleanup();
      return;
    }

    if (connectedWindow.closed) {
      clearInterval(interval);

      queryClient
        .invalidateQueries({ queryKey: userQueryKey.userInfo() })
        .then(() =>
          queryClient.fetchQuery<User>({
            queryKey: userQueryKey.userInfo(),
            queryFn: () => userApi.getUser(),
          })
        )
        .then((userData) => {
          const isAuthenticated = !!userData;
          void activeCallback?.(isAuthenticated);
          cleanup();
        })
        .catch(() => {
          void activeCallback?.(false);
          cleanup();
        });
    }
  }, 500);

  activeInterval = interval;
};
